<template>
  <div  style="background-color: #f8f8f8;min-height: 100%;padding:10px;">
    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <a @click="modal2=true">增加分组</a>
        <cite>|</cite>
        <a @click="load">刷新</a>
      </div>
    </Card>

    <Row style="margin-top:10px">
      <Col span="24">
        <Card :bordered="false"  dis-hover>
          <p slot="title">发件箱列表（{{count}}）</p>
          <el-table
            :data="list"
            size="small"
            style="width: 100%">
            <el-table-column prop="id" width="80" label="ID"></el-table-column>
            <el-table-column prop="name" label="分组名称" width="200"></el-table-column>
            <el-table-column prop="count" label="数据量" ></el-table-column>
            <el-table-column prop="" label="操作" >
              <template slot-scope="scope">
                <a @click="remove(scope.row.id)">删除</a>
                <cite>|</cite>
                <router-link :to="'/cp?id='+scope.row.id">
                  <a>进入分组</a>
                </router-link>
              </template>
            </el-table-column>
          </el-table>
        </Card>
      </Col>
    </Row>

    <Modal
      v-model="modal1"
      width="600"
      title="批量增加发件箱"
      @on-ok="save"
      @on-cancel="cancel">
      <Input type="textarea" v-model="form.boxs" :autosize="{minRows: 12,maxRows: 12}" placeholder="格式：post1@learning76.com,Leaderoot123..*,learning76.com&"></Input>
      <p>逗号是英文，每行用'&'结束，例：post1@learning76.com,Leaderoot123..*,learning76.com&</p>
    </Modal>

    <Modal
      v-model="modal2"
      title="增加分组"
      @on-ok="save2"
      @on-cancel="cancel">
      <Form :label-width="130">
        <FormItem label="分组名称" required="">
          <Input v-model="form2.name"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal
      v-model="modal3"
      title="分配发件箱"
      @on-ok="allot"
      @on-cancel="cancel">
      <Form :label-width="130">
        <FormItem label="服务器编号开始" required="">
          <InputNumber v-model="form3.start"></InputNumber>
        </FormItem>
        <FormItem label="服务器编号结束" required="">
          <InputNumber v-model="form3.stop"></InputNumber>
        </FormItem>
        <FormItem label="选择发件箱" required="">
          <Select v-model="form3.gpid">
            <Option v-for="item in list" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        list:[],
        page:1,
        limit:10,
        count:0,
        modal1:false,
        form:{
          boxs:'',
        },
        modal2:false,//增加分组
        form2:{
          name:'',
        },
        modal3:false,//分配发件箱
        form3:{
          start:0,
          stop:0,
          gpid:0,
        },
      }
    },
    methods:{
      limitchange(limit){
        this.limit = limit;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      load(){
        let that = this;
        this.$Spin.show();
        this.$axios.get('/api/cp/cpgroup/findall?page=1&limit=10000').then(function(rs){
          that.list = rs.data.data;
          that.$Spin.hide();
        });
      },
      save(){
        let that = this;
        this.$axios({url:'/api/cp/cpgroup/save',method:'post',data:this.$qs.stringify(this.form)}).then(function(rs){
          that.toast(rs.data);
        });
      },
      save2(){
        let that = this;
        this.$Spin.show();
        this.$axios({url:'/api/cp/cpgroup/save',method:'post',data:this.$qs.stringify(this.form2)}).then(function(rs){
          that.toast(rs.data);
          that.$Spin.hide();
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除分组和分组内的数据吗',
          onOk: () => {
            let that = this;
            this.$axios.get('/api//cp/cpgroup/delete?id='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      allot(){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要分配发件箱吗',
          onOk: () => {
            let that = this;
            this.$Spin.show();
            this.$axios({url:'/api/outbox/allot',method:'post',data:this.$qs.stringify(this.form3)}).then(function(rs){
              that.toast(rs.data);
              that.$Spin.hide();
            });
          },
        });
      },
      outFile(state){
        window.location = '/api/client/out?state='+state
      },
      toast(data){
        if(data.success){
          this.$Message.success(data.msg);
          this.load();
        }else{
          this.$Message.error(data.msg+"，请确保邮箱地址不重复");
        }
      }

    },
    created(){
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/cp/CpGroup.vue